(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["adc-brew-guides"] && !Shopify.designMode) return;
  try {
    
function initClubBrewGuides(scope=document){
 scope.querySelectorAll('[data-brew-guide]').forEach(root=>{
 if(root.dataset.ready)return;
 root.dataset.ready='true';
 const links=[...root.querySelectorAll('[data-brew-method]')];
 const recipes=[...root.querySelectorAll('[data-brew-recipe]')];
 const choose=(method,focus=false)=>{
 const active=recipes.find(panel=>panel.dataset.brewRecipe===method);
 if(!active)return;
 recipes.forEach(panel=>{panel.hidden=panel!==active});
 links.forEach(link=>{if(link.dataset.brewMethod===method)link.setAttribute('aria-current','true');else link.removeAttribute('aria-current')});
 if(focus){active.focus({preventScroll:true});active.scrollIntoView({behavior:'instant',block:'start'})}
 };
 links.forEach(link=>link.addEventListener('click',()=>choose(link.dataset.brewMethod,true)));
 const fromHash=()=>{const method=location.hash.replace('#brew-','');if(recipes.some(panel=>panel.dataset.brewRecipe===method))choose(method)};
 window.addEventListener('hashchange',fromHash);
 choose(recipes.some(panel=>'#brew-'+panel.dataset.brewRecipe===location.hash)?location.hash.replace('#brew-',''):'v60');
 });
}
initClubBrewGuides();
document.addEventListener('shopify:section:load',event=>initClubBrewGuides(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["adc-sample-box"]) return;
  try {
    
function initSamplePacks(root=document){
  root.querySelectorAll('.adc-sample__form').forEach(form=>{
    if(form.dataset.sampleReady)return;
    form.dataset.sampleReady='true';
    const selects=[...form.querySelectorAll('[data-sample-coffee]')];
    const update=()=>{
      selects.forEach(select=>{
        const card=select.closest('.adc-sample__card');
        const image=card.querySelector('.adc-sample__image');
        const number=card.querySelector('.adc-sample__number');
        const source=select.selectedOptions[0]?.dataset.image;
        image.hidden=!source;
        number.hidden=!!source;
        if(source)image.src=source;
      });
      const status=form.querySelector('[data-sample-progress]');
      status.textContent=status.dataset.progressTemplate.replace('__COUNT__',String(selects.filter(s=>s.value).length));
    };
    selects.forEach(select=>select.addEventListener('change',update));
    update();
  });
}
if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',()=>initSamplePacks());}else{initSamplePacks();}
document.addEventListener('shopify:section:load',event=>initSamplePacks(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
